import React from "react";
import TargetAudienceFilters from "./TargetAudienceFilters";
import SchedulingOptions from "./SchedulingOptions";

const inputClass =
  "text-xs md:text-sm w-full p-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white text-gray-700 min-w-0";

function Spinner() {
  return (
    <svg
      className="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline-block"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24">
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}

export default function SendNotificationForm({
  newNotification,
  setNotificationField,
  setUserType,
  countries,
  loadingCountries,
  searchedUser,
  setSearchedUser,
  searchingUser,
  handleSearchUser,
  handleSubmit,
  loading,
}) {
  const isSingleUser = newNotification.userType === "single-user";

  const getSubmitLabel = () => {
    if (loading) {
      return newNotification.isScheduled ? "Scheduling..." : "Sending...";
    }
    if (newNotification.userType === "single-user") return "Send to User";
    if (newNotification.isScheduled) return "Schedule Notification";
    return "Send Notification";
  };

  const handleClearUser = () => {
    setSearchedUser(null);
    setNotificationField("userId", null);
    setNotificationField("userSearchQuery", "");
  };

  return (
    <div className="bg-white p-4 sm:p-6 rounded-xl shadow-xl min-w-0 overflow-x-hidden">
      <h3 className="text-base md:text-xl font-bold text-gray-800 mb-4 sm:mb-6">
        Send Notification to Filtered Users
      </h3>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 gap-4">
          <div className="min-w-0">
            <label
              htmlFor="title"
              className="block text-sm font-semibold text-gray-700 mb-2">
              Title *
            </label>
            <input
              id="title"
              type="text"
              value={newNotification.title}
              onChange={(e) => setNotificationField("title", e.target.value)}
              className={inputClass}
              placeholder="Enter notification title"
              required
            />
          </div>
          <div className="min-w-0">
            <label
              htmlFor="message"
              className="block text-sm font-semibold text-gray-700 mb-2">
              Message *
            </label>
            <textarea
              id="message"
              value={newNotification.message}
              onChange={(e) => setNotificationField("message", e.target.value)}
              className={inputClass}
              placeholder="Enter your notification message here"
              rows="4"
              required
            />
          </div>
        </div>

        <TargetAudienceFilters
          userType={newNotification.userType}
          onUserTypeChange={setUserType}
          country={newNotification.country}
          onCountryChange={(v) => setNotificationField("country", v)}
          countries={countries}
          loadingCountries={loadingCountries}
          phoneVerified={newNotification.phoneVerified}
          profileCompletion={newNotification.profileCompletion}
          lastActive={newNotification.lastActive}
          onFilterChange={(key, value) => setNotificationField(key, value)}
          isSingleUser={isSingleUser}
          userSearchQuery={newNotification.userSearchQuery}
          onUserSearchQueryChange={(v) => {
            setNotificationField("userSearchQuery", v);
            setNotificationField("userId", null);
          }}
          onSearchUser={handleSearchUser}
          onClearUser={handleClearUser}
          searchingUser={searchingUser}
          searchedUser={searchedUser}
        />

        {!isSingleUser && (
          <SchedulingOptions
            isScheduled={newNotification.isScheduled}
            onScheduledChange={(v) => setNotificationField("isScheduled", v)}
            scheduledDate={newNotification.scheduledDate}
            scheduledTime={newNotification.scheduledTime}
            onDateChange={(v) => setNotificationField("scheduledDate", v)}
            onTimeChange={(v) => setNotificationField("scheduledTime", v)}
          />
        )}

        <div className="flex flex-col sm:flex-row justify-center md:justify-end gap-3 mt-6 pt-6 border-t border-gray-200">
          <button
            type="submit"
            disabled={loading}
            className={`text-xs md:text-sm bg-red-500 w-full sm:w-64 text-white px-6 py-3 rounded-lg font-semibold shadow-md hover:bg-red-600 hover:shadow-lg transition-all flex items-center justify-center ${
              loading ? "opacity-60 cursor-not-allowed" : ""
            }`}>
            {loading && <Spinner />}
            {getSubmitLabel()}
          </button>
        </div>
      </form>
    </div>
  );
}
